import React, { useContext } from 'react';
import { Disclosure } from '@headlessui/react';
import  Link  from "next/link";
import { useRouter } from "next/router";
import { HideMobileMenuContext } from './header';
import enIN from '@/locales/common/enIN';
import enUS from '@/locales/common/enUS';
import esMX from '@/locales/common/esMX';
import { pushCleverTapEvent } from '@/component/shared/pushCleverTapEvent';


const Mobilemenu=({ user, onShowLogin, onShowSignUp, onLogout, onShowProfile }) => {
    const router = useRouter();
    const { locale } = router;
    const t = (locale === 'es-mx' && esMX) || (locale === 'en-us' && enUS) || (locale === 'en-in' && enIN);
    
    const {open, setOpen} = useContext(HideMobileMenuContext);
   
  
    return (
        <div className="overflow-y-auto border-l border-r border-[#ccc] bg-white">
            <div className="text-sm font-semibold text-secondary w-full">
            <Disclosure as="div">
              {({ open }) => (
              <>
                {/* Login section for India */}
                {locale === 'en-in' && (
                  <>
                    {user ? (
                      // Show user profile CTA for mobile
                      <>
                        <div className="px-3 text-sm font-semibold text-secondary w-full border-b border-[#ccc]">
                          <button
                            onClick={() => {
                              if (onShowProfile) onShowProfile();
                              setOpen(false);
                            }}
                            className="w-full bg-brand bg-opacity-10 text-brand rounded-lg py-2 px-2.5 flex items-center justify-between hover:bg-opacity-70 transition-all mb-2"
                          >
                            <div className="flex items-center gap-2">
                              {/* Profile Icon */}
                              <div className="w-10 h-10 bg-brand text-white rounded-full flex items-center justify-center font-semibold">
                                {(user.name || user.email)?.charAt(0)?.toUpperCase()}
                              </div>
                              {/* Truncated Name/Email */}
                              <span className="font-medium text-base">
                                {((user.name || user.email)?.length > 8 
                                  ? (user.name || user.email)?.substring(0, 8) + '...' 
                                  : (user.name || user.email))}
                              </span>
                            </div>
                            {/* Right Arrow */}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="20"
                              height="20"
                              fill="currentColor"
                            >
                              <path d="M13.1717 12.0007L8.22192 7.05093L9.63614 5.63672L16.0001 12.0007L9.63614 18.3646L8.22192 16.9504L13.1717 12.0007Z"></path>
                            </svg>
                          </button>
                        </div>
                      </>
                    ) : (
                      // Show login/signup buttons for mobile
                      <>
                        <div className="px-4 text-sm font-semibold text-secondary w-full border-b border-[#ccc]">
                          <button
                            onClick={() => {
                              onShowLogin();
                              setOpen(false);
                              {t.Login.eventsname && pushCleverTapEvent(t.Login.eventsname, { PageName: t.Login.PageName });}
                            }}
                            className="text-secondary block leading-[56px] h-14 w-full text-left"
                          >
                            {t.Login?.name || 'Login'}
                          </button>
                        </div>
                        {/* <div className="px-4 text-sm font-semibold text-secondary w-full border-b border-[#ccc]">
                          <button
                            onClick={() => {
                              onShowSignUp();
                              setOpen(false);
                              {t.SignUp.eventsname && pushCleverTapEvent(t.SignUp.eventsname,{"PageName": t.SignUp.PageName,})}
                            }}
                            className="text-secondary block leading-[56px] h-14 w-full text-left"
                          >
                            {t.SignUp?.name || 'Sign Up'}
                          </button>
                        </div> */}
                      </>
                    )}
                  </>
                )}

                {/* Login section for Mexico and USA */}
                {(locale === 'es-mx' || locale === 'en-us') && (
                  <>
                    <div className="px-4 text-sm font-semibold text-secondary w-full border-b border-[#ccc]">
                      <Link
                        href={t.Login.href}
                       
                        onClick={() => {
                          setOpen(false);
                          {t.Login.eventsname && pushCleverTapEvent(t.Login.eventsname, { PageName: t.Login.PageName });}
                        }}
                        rel="noopener noreferrer"
                        className="text-secondary block leading-[56px] h-14"
                      >
                        {t.Login?.name || 'Login'}
                      </Link>
                    </div>
                    <div className="px-4 text-sm font-semibold text-secondary w-full border-b border-[#ccc]">
                      <Link
                        href={t.SignUp.href}
                        // target='_blank'
                        onClick={() => {
                          setOpen(false);
                          {t.SignUp.eventsname && pushCleverTapEvent(t.SignUp.eventsname, { PageName: t.SignUp.PageName });}
                        }}
                        rel="noopener noreferrer"
                        className="text-secondary block leading-[56px] h-14"
                      >
                        {t.SignUp?.name || 'Sign Up'}
                      </Link>
                    </div>
                  </>
                )}

                {t.MenuLinks.map((item, i) => (
                  <div key={i}>
                    {item.subMenu ? (
                      <Disclosure>
                        {({ open: subMenuOpen }) => (
                          <>
                            <Disclosure.Button
                              className="flex w-full items-center justify-between px-4 border-b h-14 border-[#ccc]">
                              <div
                                onClick={() => setOpen(false)}
                                className={
                                  router.pathname == item.href
                                    ? "text-brand flex justify-between"
                                    : "flex justify-between"
                                }
                              >
                                {item.name}
                              </div>
                              <span className="ml-6 block items-center">
                                {subMenuOpen ? (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    width="24"
                                    height="24"
                                  >
                                    <path fill="none" d="M0 0h24v24H0z" />
                                    <path d="M12 10.828l-4.95 4.95-1.414-1.414L12 8l6.364 6.364-1.414 1.414z" />
                                  </svg>
                                ) : (
                                  <svg
                                    className="ml-1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    width="16"
                                    height="16"
                                  >
                                    <path fill="none" d="M0 0h24v24H0z" />
                                    <path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" />
                                  </svg>
                                )}
                              </span>
                            </Disclosure.Button>
                            <Disclosure.Panel className="bg-graybg px-4">
                              <div className="space-y-6">
                                <div className="relative py-2">
                                  <ul>
                                    {item.subMenu.map((item1, index) => (
                                      <li
                                        key={index}
                                        className={
                                          router.asPath == item1.href
                                            ? "text-brand font-medium"
                                            : "font-regular"
                                        }
                                      >
                                        <Link
                                          href={item1.href}
                                          rel="noopener noreferrer"
                                          onClick={() => setOpen(false)}
                                          className="block text-sm rounded-md p-1 transition duration-150 ease-in-out hover:text-brand"
                                        >
                                          {item1.name}
                                        </Link>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </div>
                            </Disclosure.Panel>
                          </>
                        )}
                      </Disclosure>
                    ) : (
                      <div className="px-4 text-sm font-semibold text-secondary w-full border-b border-[#ccc]">
                        <Link
                          href={item.href}
                          rel="noopener noreferrer"
                          onClick={() => setOpen(false)}
                          className="text-secondary block leading-[56px] h-14"
                        >
                          {item.name}
                        </Link>
                      </div>
                    )}
                  </div>
                ))}
             
              </>
              )}
              </Disclosure>

            </div>
            
        
    </div>
    )
        
    
    

}

export default Mobilemenu;
